// extracted by mini-css-extract-plugin
export default {"wrapper":"ks-z","response":"ls-z","error":"ms-z","disabled":"ns-z","buttons":"os-z","feedbackQuestionSection":"ps-z","yesNoWrapper":"qs-z"};